import request from '@/utils/request'

let cachedAccess = null
let cachedAt = 0
const ACCESS_CACHE_MS = 30 * 1000

function unwrap(response) {
  return response?.data ?? response
}

export async function getExpertReviewAccess(options = {}) {
  const force = options.force === true
  if (!force && cachedAccess && Date.now() - cachedAt < ACCESS_CACHE_MS) {
    return cachedAccess
  }
  const response = await request.get('/expert-review/access')
  cachedAccess = unwrap(response)
  cachedAt = Date.now()
  return cachedAccess
}

export function clearExpertReviewAccessCache() {
  cachedAccess = null
  cachedAt = 0
}

export async function getExpertReviewUsers() {
  return unwrap(await request.get('/expert-review/users'))
}

export async function getExpertReviewOverview() {
  return unwrap(await request.get('/expert-review/overview'))
}

export async function getExpertReviewQuestions() {
  return unwrap(await request.get('/expert-review/questions'))
}

export async function assignExpertReviewers(reviewerUserIds) {
  const result = unwrap(await request.post('/expert-review/assignments', { reviewerUserIds }))
  clearExpertReviewAccessCache()
  if (typeof window !== 'undefined') window.dispatchEvent(new Event('expert-review-access-changed'))
  return result
}

export async function getMyExpertReview(assignmentId = null) {
  return unwrap(await request.get('/expert-review/my-review', {
    params: assignmentId ? { assignmentId } : undefined
  }))
}

export async function saveExpertReviewDraft(assignmentId, responses) {
  return unwrap(await request.put(`/expert-review/assignments/${assignmentId}/draft`, { responses }))
}

export async function submitExpertReview(assignmentId, payload) {
  const result = unwrap(await request.post(`/expert-review/assignments/${assignmentId}/submit`, payload))
  clearExpertReviewAccessCache()
  return result
}
